import client from '../userApi';

export default {
    getVerificationOptions() {
        return client.get('/lk/verification-options');
    },

    startVerification({ phone, verificationType }) {
        return client.post('/lk/start-verification', {
            phone,
            verification_type: verificationType
        });
    },

    getVerificationStatus({ phone, verificationType }) {
        return client.post('/lk/verification-status', {
            phone,
            verification_type: verificationType
        });
    },

    login({ phone }) {
        return client.post('/lk/login', { phone });
    },

    logout() {
        return client.post('/lk/logout');
    },

    auth({ phone, code }) {
        return client.post('/lk/verify', { code, phone });
    },

    me() {
        return client.get('/auth/user/me');
    }
};
